import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import '../../css/immocom.css';
import { DataTMA } from '../../data/DataTMA.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheTMA.css';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifierBlocTMA
    peutAjouterBlocTMA

    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    tma: {},
    listTMAs: [],
    totalFacture: 0,
    totalEncaisse: 0,
    totalAEncaisser: 0,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    //peutModifierBlocTMA: false,

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheTMA extends Component {
    _creationContent() {

        return (
            <div className="ms-Grid" dir="ltr">
                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <div className="ms-Grid-row">
                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />
                </div>

                <div className="ms-Grid-row blocTotauxTMA">
                    <div className="ms-Grid-col ms-sm12 ms-xl6" />
                    <div className="ms-Grid-col ms-sm12 ms-xl6">
                        <div className="ms-Grid-col ms-sm12 ms-lg4">
                            <div className="divTotalTMA">
                                <span className="labelMontantTMA">Total facturé : </span>
                                <span className="montantTMA">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.totalFacture)}&nbsp;€</span>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg4">
                            <div className="divTotalTMA">
                                <span className="labelMontantTMA">Total encaissé : </span>
                                <span className="montantTMA">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.totalEncaisse)}&nbsp;€</span>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg4">
                            <div className="divTotalTMA">
                                <span className="labelMontantTMA">Total à encaisser : </span>
                                <span className="montantTMA">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.totalAEncaisser)}&nbsp;€</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-xl6 blocTMA">
                        <div className="ms-Grid-row">
                            <div className="titreBlocTMA">Travaux Modificatifs Acquéreurs</div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <EUITextField
                                    label="Désignation"
                                    maxLength={MaxLengths.tma.designation}
                                    onDelayedChange={(event, newValue) => this._onMiseAJourChamp("tma", "designation", newValue, this._onVerificationFormulaire)}
                                    required
                                    value={this.state.tma.designation}
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12">
                                <TextField // Note KP : TextFieldNombre en cours de test
                                    label="Montant devis"
                                    required
                                    value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'tma', 'montantTTCDevis', false, 2)}
                                    onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'tma', 'montantTTCDevis', this._onVerificationFormulaire)}
                                    onBlur={e => this._onMiseAJourChampNombre("tma", "montantTTCDevis", e.target.value, this._onVerificationFormulaire)}
                                    onChanged={value => this._onMiseAJourChamp("tma", "montantTTCDevis", value, this._onVerificationFormulaire)}
                                    onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantTTCDevis', e, false, 2)}
                                    deferredValidationTime={0}
                                    suffix="€"
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUIDatePicker
                                    isRequired
                                    label="Date devis"
                                    onSelectDate={date => this._onMiseAJourChamp("tma", "dateDevis", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.tma.dateDevis}
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <EUIDatePicker
                                    isRequired
                                    label="Date acceptation"
                                    onSelectDate={date => this._onMiseAJourChamp("tma", "dateAcceptation", Scriba.date().getChaineISOFromDate(date), this._onVerificationFormulaire)}
                                    value={this.state.tma.dateAcceptation}
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <TextField // Note KP : TextFieldNombre en cours de test
                                    label="Montant facturé"
                                    required
                                    value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'tma', 'montantTTCFacturer', false, 2)}
                                    onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'tma', 'montantTTCFacturer', this._onVerificationFormulaire)}
                                    onBlur={e => this._onMiseAJourChampNombre("tma", "montantTTCFacturer", e.target.value, this._onVerificationFormulaire)}
                                    onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantTTCFacturer', e, false, 2)}
                                    deferredValidationTime={0}
                                    suffix="€"
                                />
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-lg6">
                                <TextField // Note KP : TextFieldNombre en cours de test
                                    label="Montant encaissé"
                                    required
                                    value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'tma', 'montantTTCEncaisser', false, 2)}
                                    onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'tma', 'montantTTCEncaisser', this._onVerificationFormulaire)}
                                    onBlur={e => this._onMiseAJourChampNombre("tma", "montantTTCEncaisser", e.target.value, this._onVerificationFormulaire)}
                                    onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantTTCEncaisser', e, false, 2)}
                                    deferredValidationTime={0}
                                    suffix="€"
                                />
                            </div>
                        </div>
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 boutonBlocTMA">
                                <PrimaryButton onClick={() => this._onEnregistrement()} disabled={!this.state.onActiveBoutonEnregistrer} style={{ marginRight: '8px' }}>Enregistrer</PrimaryButton>
                                <DefaultButton onClick={() => this.setState({ tma: {} }, this._onVerificationFormulaire)}>Annuler</DefaultButton>
                            </div>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <DetailsList
                                items={this.state.listTMAs}
                                columns={this.columns}
                                selectionMode={SelectionMode.none}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        //#region chargement des columns
        let columnsTemp = [];

        if (this.props.peutModifierBlocTMA) {
            columnsTemp.push({
                key: 'designation',
                name: 'Désignation TMA',
                fieldName: 'designation',
                minWidth: 100,
                maxWidth: 190,
                isResizable: true,
                onRender: (item) => {
                    return <span className="labelTMA" onClick={() => this.setState({ tma: item }, this._onVerificationFormulaire)}>{item.designation}</span>;
                }
            });
        }
        else {
            columnsTemp.push({
                key: 'designation',
                name: 'Désignation TMA',
                fieldName: 'designation',
                minWidth: 100,
                maxWidth: 190,
                isResizable: true,
                onRender: (item) => {
                    return <span>{item.designation}</span>;
                }
            });
        }

        columnsTemp.push({
            key: 'montantTTCDevis',
            name: 'Montant devis',
            fieldName: 'montantTTCDevis',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => {
                return (item.montantTTCDevis !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.montantTTCDevis, false, 2)}&nbsp;€</span> : null);
            }
        });
        columnsTemp.push({
            key: 'dateDevis',
            name: 'Date devis',
            fieldName: 'dateDevis',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',

            onRender: (item) => {
                return <span>{Scriba.date().stringDateFormatCourt(item.dateDevis)}</span>;
            }
        });
        columnsTemp.push({
            key: 'dateAcceptation',
            name: 'Date acceptation',
            fieldName: 'dateAcceptation',
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',

            onRender: (item) => {
                return <span>{Scriba.date().stringDateFormatCourt(item.dateAcceptation)}</span>;
            }
        });
        columnsTemp.push({
            key: 'montantTTCFacturer',
            name: 'Montant facturé',
            fieldName: 'montantTTCFacturer',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                return (item.montantTTCFacturer !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.montantTTCFacturer, false, 2)}&nbsp;€</span> : null);
            }
        });
        columnsTemp.push({
            key: 'montantTTCEncaisser',
            name: 'Montant encaissé',
            fieldName: 'montantTTCEncaisser',
            minWidth: 80,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                return <span>
                    {item.montantTTCEncaisser !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.montantTTCEncaisser, false, 2) : 0}&nbsp;€
                </span>
            }
        });

        if (this.props.peutSupprimerBlocTMA) {
            columnsTemp.push({
                key: 'suppression',
                name: '',
                ariaLabel: 'Suppression TMA',
                fieldName: 'suppression',
                minWidth: 20,
                maxWidth: 20,
                iconName: '',
                isIconOnly: true,
                isSorted: false,
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer"
                        ariaLabel="Suppression"
                        onClick={() => this._onSuppression(item.idTMA)} />;
                }
            });
        }

        this.columns = columnsTemp;
        //#endregion

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onChargement(chargementInitial) {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (chargementInitial) {
            if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
                this._chargementDonnees();
            }
        }
        else {
            if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent && !this.state.enCoursDeTraitement) {
                this._chargementDonnees();
            }
        }
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des TMA'
        });

        let chargementTMA = DataTMA._chargementTMA(this.props.idOperation, this.props.idReservation);

        chargementTMA
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    // Calcul totaux
                    let totalFacture = 0;
                    let totalEncaisse = 0;

                    objetData.forEach(function (tma) {
                        totalFacture = totalFacture + (tma.montantTTCFacturer !== null ? parseFloat(tma.montantTTCFacturer) : 0);
                        totalEncaisse = totalEncaisse + (tma.montantTTCEncaisser !== null ? parseFloat(tma.montantTTCEncaisser) : 0);
                    });

                    let stateTemp = {};
                    stateTemp.idReservation = this.props.idReservation;
                    stateTemp.idOperation = this.props.idOperation;
                    stateTemp.tma = {};
                    stateTemp.listTMAs = objetData;
                    stateTemp.totalFacture = totalFacture;
                    stateTemp.totalEncaisse = totalEncaisse;
                    stateTemp.totalAEncaisser = totalFacture - totalEncaisse;


                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    //_validationFormulaire(item) {
    //    let estValide = true;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        estValide =
    //            (Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutModifierBlocTMA) |
    //            (!Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutAjouterBlocTMA);

    //        estValide = estValide && Scriba.formulaire().nEstPasVide(item.designation);
    //        estValide = estValide && (item.montantTTCDevis > 0) && (Scriba.nombre().nombreEstValide(item.montantTTCDevis));
    //        estValide = estValide && (item.montantTTCFacturer > 0) && (Scriba.nombre().nombreEstValide(item.montantTTCFacturer));
    //        estValide = estValide && (item.montantTTCEncaisser > 0) && (Scriba.nombre().nombreEstValide(item.montantTTCEncaisser));
    //    }
    //    else {
    //        estValide = false;
    //    }

    //    return estValide;
    //}

    //_validationFormulaire(item) {
    //    let estValide = false;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        estValide = (Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutModifierBlocTMA) |
    //            (!Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutAjouterBlocTMA);

    //        if (estValide) {
    //            let tmaTrav = { ...item };
    //            tmaTrav.idOperation = this.props.idOperation;
    //            tmaTrav.idReservation = this.props.idReservation;

    //            let typeEnregistrement = (item.idTMA > 0 ? 'Modification' : 'Création');
    //            var validationFormulaire = Data._onValidationFormulaire('TMA', tmaTrav, typeEnregistrement);

    //            validationFormulaire
    //                .then(responseFetch => {
    //                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

    //                    if (retourVerif !== null) {
    //                        estValide = false;
    //                    }
    //                    else {
    //                        estValide = true;
    //                    }

    //                    if (this.state.onActiveBoutonEnregistrer !== estValide) {
    //                        this.setState({ onActiveBoutonEnregistrer: estValide });
    //                    }
    //                });
    //        }
    //    }
    //}

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du TMA'
        });

        var enregistrementTMA = DataTMA._onEnregistrementTMA(this.props.idOperation, this.props.idReservation, this.state.tma);

        enregistrementTMA
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onSuppression(idTMA) {
        if (window.confirm("Voulez-vous supprimer ce TMA ?")) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Suppression du TMA'
            });

            var suppressionTMA = DataTMA._onSuppressionTMA(idTMA);

            suppressionTMA
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        this._chargementDonnees();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    //_onRenderFooterContent = () => {
    //    let estValide = (Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutModifierBlocTMA) | (!Scriba.formulaire().nEstPasVide(item.idTMA) & this.props.peutAjouterBlocTMA);

    //    if (estValide) {
    //        let tmaTrav = { ...this.state.tma };
    //        tmaTrav.idOperation = this.props.idOperation;
    //        tmaTrav.idReservation = this.props.idReservation;

    //        //TD : 17/08/2020
    //        Immocom.fiche()._validationFormulaire(this, 'TMA', this.state.tma, (item.idTMA > 0 ? 'Modification' : 'Création'));
    //    }
    //    else {
    //        this.setState({ onActiveBoutonEnregistrer: false });
    //    }

    //    return (
    //        <div>
    //            <PrimaryButton onClick={() => this._onEnregistrement()} style={{ marginRight: '8px' }} disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
    //            <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
    //        </div>
    //    );
    //};

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur, callBack) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, callBack);
    }

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur, callBack) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr', callBack);
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'TMA', this.state.tma, (this.state.tma.idTMA > 0 ? 'Modification' : 'Création'));
    }

    componentDidMount() {
        this._onChargement(true);
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        if ((this.props.idReservation !== 0 && this.props.idReservation != null && this.props.idReservation !== this.state.idReservation) && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation) && !this.state.enCoursDeTraitement) {
            this._chargementDonnees();
        }
    }

    render() {
        return (this._creationContent());
    }
}